import { render, staticRenderFns } from "./EmployeeSettingsDeleteEmployee.vue?vue&type=template&id=17620c7d&"
import script from "./EmployeeSettingsDeleteEmployee.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingsDeleteEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports